/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Who or what initiated a question advance (API mirror of AdvanceTrigger).
 */
export type OralExamAdvanceTrigger = (typeof OralExamAdvanceTrigger)[keyof typeof OralExamAdvanceTrigger];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamAdvanceTrigger = {
  lecturer_next: 'lecturer_next',
  student_done: 'student_done',
  deadline_expired: 'deadline_expired',
  agent_next: 'agent_next',
} as const;
